import cn from 'classnames';
import React from 'react';

export enum ChipColor {
  BUTTER_100 = 'BUTTER_100',
  BUTTER_50 = 'BUTTER_50',
  CANTELOUPE_50 = 'CANTELOUPE_50',
  EGGPLANT_50 = 'EGGPLANT_50',
  ELDERBERRY_25 = 'ELDERBERRY_25',
  ELDERBERRY_50 = 'ELDERBERRY_50',
  JACKFRUIT_200 = 'JACKFRUIT_200',
  MINT_50 = 'MINT_50',
  MINT_100 = 'MINT_100',
  NEUTRAL_50 = 'NEUTRAL_50',
  RADISH_50 = 'RADISH_50',
  RASPBERRY = 'RASPBERRY',
  SOURDOUGH = 'SOURDOUGH',
  STRAWBERRY_100 = 'STRAWBERRY_100',
  WHITE = 'WHITE',
  RICE = 'RICE',
  MILK = 'MILK',
}

const colorVariants = {
  [ChipColor.BUTTER_100]: `bg-butter-100`,
  [ChipColor.BUTTER_50]: `bg-butter-50`,
  [ChipColor.CANTELOUPE_50]: `bg-canteloupe-50`,
  [ChipColor.EGGPLANT_50]: `bg-eggplant-50`,
  [ChipColor.ELDERBERRY_25]: `bg-elderberry-25`,
  [ChipColor.ELDERBERRY_50]: `bg-elderberry-50`,
  [ChipColor.JACKFRUIT_200]: `bg-jackfruit-200`,
  [ChipColor.MINT_50]: `bg-mint-50`,
  [ChipColor.MINT_100]: `bg-mint-100 text-mint-600`,
  [ChipColor.NEUTRAL_50]: `bg-neutral-50`,
  [ChipColor.RADISH_50]: `bg-radish-50`,
  [ChipColor.RASPBERRY]: `bg-raspberry text-white`,
  [ChipColor.SOURDOUGH]: `bg-sourdough`,
  [ChipColor.STRAWBERRY_100]: `bg-strawberry-100`,
  [ChipColor.WHITE]: `bg-white`,
  [ChipColor.RICE]: `bg-rice`,
  [ChipColor.MILK]: `bg-milk`,
};

const BASE_CSS = 'rounded flex gap-0.5 text-label-400 items-center text-eggplant w-fit';

interface ChipProps {
  fontWeight?: 'bold' | 'normal';
  color: ChipColor;
  copy: React.ReactNode;
  applyFullHeight?: boolean;
  icon?: React.ReactNode; // TODO: Restrict to Icon component
  paddingPixels?: 4 | 8;
}

const Chip: React.FC<ChipProps> = ({
  fontWeight = 'normal',
  applyFullHeight = false,
  paddingPixels = 8,
  color,
  copy,
  icon,
}) => (
  <div
    className={cn(BASE_CSS, colorVariants[color], {
      'text-label-600': fontWeight === 'bold',
      'text-label-400': fontWeight === 'normal',
      'h-full min-h-6': applyFullHeight,
      'h-7': !applyFullHeight,
      'px-1': paddingPixels === 4,
      'px-2': paddingPixels === 8,
    })}>
    {icon && <span className='flex w-fit items-center justify-center'>{icon}</span>}
    {copy && <span className='mt-0.5 text-nowrap leading-3'>{copy}</span>}
  </div>
);
export default Chip;
